import { GALLERY } from '../constants/restaurant';

export const Gallery = () => {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="bg-brand-ivory py-24 md:py-32 px-6 md:px-12 lg:px-16"
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div>
            <p className="text-xs uppercase tracking-[0.3em] font-semibold text-brand-burgundy mb-5">
              The Atmosphere
            </p>
            <h2
              data-testid="gallery-heading"
              className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-brand-coffee tracking-tight max-w-2xl"
            >
              Glimpses from inside{' '}
              <span className="italic text-brand-burgundy">Sankalp</span>.
            </h2>
          </div>
          <p className="max-w-sm text-brand-mocha text-base">
            Vibrant plates, warm lighting and the everyday joy of breaking bread together.
          </p>
        </div>

        <div className="grid grid-cols-12 grid-rows-6 gap-3 md:gap-5 h-[640px] md:h-[760px]">
          <GalleryItem src={GALLERY[0].url} alt={GALLERY[0].alt} className="col-span-7 row-span-3" />
          <GalleryItem src={GALLERY[1].url} alt={GALLERY[1].alt} className="col-span-5 row-span-2" />
          <GalleryItem src={GALLERY[2].url} alt={GALLERY[2].alt} className="col-span-5 row-span-2 col-start-8 row-start-3" />
          <GalleryItem src={GALLERY[3].url} alt={GALLERY[3].alt} className="col-span-4 row-span-3 col-start-1 row-start-4" />
          <GalleryItem src={GALLERY[4].url} alt={GALLERY[4].alt} className="col-span-4 row-span-3 col-start-5 row-start-4" />
          <GalleryItem src={GALLERY[5].url} alt={GALLERY[5].alt} className="col-span-4 row-span-2 col-start-9 row-start-5" />
        </div>
      </div>
    </section>
  );
};

const GalleryItem = ({ src, alt, className = '' }) => (
  <div
    className={`relative overflow-hidden rounded-2xl shadow-[0_15px_40px_rgba(43,27,23,0.10)] group ${className}`}
  >
    <img
      src={src}
      alt={alt}
      loading="lazy"
      className="w-full h-full object-cover transition-transform duration-[1400ms] group-hover:scale-110"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-brand-coffee/30 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
  </div>
);

export default Gallery;
